'use client'

import { cn } from '@/utils/utils'

import { VueMark } from './vue-mark'

/**
 * Vue's icon in the app registry.
 *
 * Sized by whatever class the slot hands over (`size-3.5` on a tile, `size-4`
 * in the switcher trigger) rather than by a `size` prop.
 *
 * `scale-150` because the mark is three thin shards around a void: it carries
 * less ink than the solid lucide glyphs beside it and reads small at 14–16px.
 */
export function VueAppIcon({ className }: { className?: string }) {
  // `size-4` first so a slot's own size- class still wins
  return <VueMark className={cn('size-4 scale-150', className)} label={null} />
}
